export default __webpack_public_path__ + "static/media/techniftsy.7bd1c8d6.svg";